import * as _ from 'underscore';
import { IFilterFunc } from '../interfaces';
import { StringComparer, FilterOperator } from '../enums';

export class FilterUtil {
	static func: IFilterFunc = {
		[FilterOperator.EQUALS]: (val1: any, params: any[]) => {
			return val1 === params[0];
		},
		[FilterOperator.STARTSWITH]: (
			val1: string,
			params: any[],
			stringComparer: StringComparer = StringComparer.CaseInSensitive
		) => {
			let startsWithVal: string = ko.isObservable(params[0])
				? (<KnockoutObservable<any>>params[0])()
				: params[0];
			if (stringComparer == StringComparer.CaseInSensitive && startsWithVal) {
				startsWithVal = startsWithVal.toLocaleLowerCase();
				val1 = val1.toLocaleLowerCase();
			}
			return val1.indexOf(startsWithVal) === 0;
		},
		[FilterOperator.ENDSWITH]: (
			val1: string,
			params: any[],
			stringComparer: StringComparer = StringComparer.CaseInSensitive
		) => {
			let endsWithVal: string = ko.isObservable(params[0])
				? (<KnockoutObservable<any>>params[0])()
				: params[0];
			let index;
			if (stringComparer == StringComparer.CaseInSensitive && endsWithVal) {
				endsWithVal = endsWithVal.toLocaleLowerCase();
				val1 = val1.toLocaleLowerCase();
			}
			return (
				(index = val1.lastIndexOf(endsWithVal)) >= 0 && index + endsWithVal.length === val1.length
			);
		},
		[FilterOperator.LIKE]: (
			val1: string | number,
			params: any[],
			stringComparer: StringComparer = StringComparer.CaseInSensitive
		) => {
			val1 = val1.toString();
			let likeVal = ko.isObservable(params[0]) ? (<KnockoutObservable<any>>params[0])() : params[0];
			if (stringComparer == StringComparer.CaseInSensitive && likeVal) {
				likeVal = likeVal.toLocaleLowerCase();
				val1 = val1.toLocaleLowerCase();
			}
			return val1.indexOf(likeVal) >= 0;
		},
		[FilterOperator.GREATEROREQUALTHAN]: (val1: any, params: any[]) => {
			return val1 >= params[0];
		},
		[FilterOperator.GREATERTHAN]: (val1: any, params: any[]) => {
			return val1 > params[0];
		},
		[FilterOperator.SMALLEROREQUALTHAN]: (val1: any, params: any[]) => {
			return val1 <= params[0];
		},
		[FilterOperator.SMALLERTHAN]: (val1: any, params: any[]) => {
			return val1 < params[0];
		},
		[FilterOperator.ISNOTIN]: (val1: any, params: any[]) => {
			let arr: any[] = ko.isObservable(params[0])
				? (<KnockoutObservableArray<any>>params[0])()
				: params[0];
			if (_.isArray<any>(arr) && arr.length > 0) {
				return arr.indexOf(val1) < 0;
			}
			return true;
		}
	};
}
